<template>
    <div class="contact">
        <div class="contact-box-wraper">
            <div class="contact-section left-section">
                <div class="contact-search">
                    <el-input :placeholder="$t('Search')" clearable v-model="search" @keyup.native="dosearch">
                        <i
                            class="components-icons components-icons-search"
                            slot="prefix">
                        </i>
                    </el-input>
                </div>
                <div class="search-list" ref="scrollbody" @scroll="handleScroll">
                    <div class="users-list">
                        <div class="user-item" @click="disableds.indexOf(item.userid) > -1 ? '' : doSelected(item.userid)" v-for="item in list" :key="item.userid">
                            <div class="member-avatar">
                                <img :src="item.avatar" class="el-tooltip item" style="width: 24px; height: 24px;">
                            </div>
                            <div class="member-info">
                                <div class="member-name nowrap" :title="item.nickname" v-html="search ? getHtml(item.nickname) : item.nickname"></div>
                                <div class="member-email nowrap" :title="item.email" v-html="search ? getHtml(item.email) : item.email"></div>
                            </div>
                            <div :class="`member-selection${disableds.indexOf(item.userid) > -1 ? ' disable' : ''}`">
                                <i :class="`${selected.indexOf(item.userid) > -1 ||  disableds.indexOf(item.userid) > -1 ? 'components-icons components-icons-success' : 'member-unselect'}`"><span class="path1"></span></i>
                                <!-- <span class="member-unselect"></span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact-section right-section">
                <div class="selected-title">
                    <span v-if="!selected.length" class="empty-selected">{{$t('Emptytip')}}</span>
                    <span class="select-tip nowrap" v-if="selected.length">{{$t('Selectedusers',{num:selected.length})}}</span>
                    <template v-if="!dialogData.from">
                        <span class="member-permission-select" v-if="selected.length && !extraData.editable">{{$t('view')}}</span>
                        <el-dropdown  v-if="selected.length && extraData.editable" trigger="click" placement="bottom-end" @command="switchPer">
                            <span class="member-permission-select">{{$t(permission)}}<span class="components-icons-box"><i class="components-icons components-icons-down"><span class="path1"></span></i></span></span>
                            <el-dropdown-menu 
                                slot="dropdown" 
                                :visible-arrow="false"
                                class="list-actions member-permission"
                                >
                                <el-dropdown-item :class="[`list-action-item`,permission == 'edit' ? 'checked' : '']" command="edit">
                                    <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('edit')}}</div>
                                </el-dropdown-item>
                                <el-dropdown-item :class="[`list-action-item`,permission == 'view' ? 'checked' : '']" command="view">
                                    <div class="list-action-inner"><div class="list-checked"><i class="components-icons components-icons-check"><span class="path1"></span></i></div>{{$t('view')}}</div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </div>
                <div class="selected-members">
                    <div class="selected-item" v-for="item in selectedPeo" :key="item.userid">
                        <div class="member-avatar">
                            <img :src="item.avatar" class="el-tooltip item" style="width: 24px; height: 24px;">
                        </div>
                        <div class="member-info">
                            <div class="member-name nowrap" :title="item.nickname">{{item.nickname}}</div>
                        </div>
                        <div class="member-selection" @click="doSelected(item.userid)">
                            <i class="components-icons components-icons-close"></i>
                        </div>
                    </div>
                </div>
                <div class="contact-buttons">
                    <el-button @click="() => back('update')">{{$t('Cancel')}}</el-button>
                    <el-button type="primary" @click="confirm" :disabled="!selected.length" plain>{{$t('Confirm')}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getContacts,addContacts,searchContacts} from '@/store/service/contact'
import {mapMutations,mapState} from 'vuex'
export default {
    data(){
        return {
            search: '',
            selected: [],
            selectedPeo: [],
            list: [],
            permission: 'edit',
            maxPage: false,
            currentPage: 1,
            pageCount: 10
        }
    },
    async created(){
        this.getContacts()
    },
    mounted(){

    },
    computed:{
        ...mapState([
            'dialogTitle',
            'dialogIco',
            'dialogData',
            'extraData'
        ]),
        disableds(){
            return this.extraData.members ? this.extraData.members.map(item => item.invitee.id) : []
        }
    },
    methods:{
        ...mapMutations([
            'SHOW_DIALOG',
            'SET_EXTRA'
        ]),
        getHtml(str){
            let kw = this.search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            return str.replace(new RegExp(kw, 'ig'),($1, $2) => '<a class="highlight">' + $1 + '</a>')
        },
        getContacts(){
            if (this.maxPage) {
                return
            }
            let {pageCount,currentPage} = this
            getContacts({
                offset: (currentPage - 1) * pageCount,
                limit: pageCount
            },({status,data}) => {
                if (status == 200) {
                    let contacts = data.contacts
                    contacts.length < this.pageCount ? this.maxPage = true : ''
                    this.list = this.list.concat(contacts)
                }
            })
        },
        handleScroll(){
            let target = this.$refs.scrollbody
            let contentHeight = target.offsetHeight || target.clientHeight
            let scrollTop = target.scrollTop
            let contentInnerHeight = target.scrollHeight
            if (contentInnerHeight - (scrollTop + contentHeight) >= 1 || scrollTop == 0 ) {
                return
            }
            this.currentPage += 1
            this.getContacts() 
        },
        dosearch(){
            if (this.search) {
                searchContacts(this.search,({status,data}) => {
                    if (status == 200) {
                        this.list = data.contacts
                    }
                })
            }else{
                this.currentPage = 1
                this.maxPage = false
                this.list = []
                this.getContacts()
            }
        },
        switchPer(e){
            this.permission = e
        },
        confirm(){
            let {groupid,fileid,from} = this.dialogData
            from ? addMembers({
                
            },({status,data}) => {

            }) :
            addContacts({
                groupid,
                fileid,
                invitees: this.selected,
                permission: this.extraData.editable ? this.permission : 'view'
            },({status,data}) => {
                if (status == 200) {
                    this.back('update')
                    this.SET_EXTRA({
                        updated: false
                    })
                }
            })
        },
        doSelected(id){
            let idx = this.selected.indexOf(id) 
            if (idx > -1) {
                this.selected.splice(idx,1)
                this.selectedPeo.splice(idx,1)
            }else{
                let data
                this.list.map(item => {
                    item.userid == id ? data = item : ''
                    return item
                })
                this.selected.push(id)
                this.selectedPeo.push(data)
            }
        },
        back(type){
            let {from,role,tid} = this.dialogData
            if (from) {
                this.backTeam(type)
            }else{
                this.dialogData.close()
            }
        },
        backTeam(uinit){
            let {from,role,tid} = this.dialogData
            this.SHOW_DIALOG({
                title: `${this.$t('TeamMember')}`,
                size: 'large',
                current: 'TeamShare',
                header: false,
                dialogData:{
                    tid,
                    role,
                    uinit
                }
            })
        }
    }
}
</script>

<style>
.contact-box-wraper{
    padding-top: 30px;
    height: 350px;
    display: flex;
}
.contact-section{
    flex: 1;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.left-section{
    padding-right: 3px;
}
.right-section{
    border-left: 1px solid #e7e9eb;
    padding-left: 20px;
}
.contact-search{
    margin: 0 27px 15px 0;
    height: 30px;
}
.contact-search .components-icons{
    font-size: 16px;
    height: 16px;
    color: #2e68f8;
    line-height: 30px;
}
.contact-search .el-input__prefix{
    width: 38px;
}
.contact-search .el-input--prefix .el-input__inner:focus,.contact-search .el-input--prefix .el-input__inner:hover{
    outline: none;
    border: none;
}
.contact-search .el-input--prefix .el-input__inner{
    padding-left: 38px;
    height: 30px;
    outline: none;
    border: none;
    background: #f7f9fb;
}
.search-list{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}
.users-list{
    padding-right: 27px;
}
.user-item{
    padding: 0 12px 0 8px;
    height: 46px;
    line-height: 46px;
    display: flex;
}
.member-avatar{
    flex: 0 0 36px;
    display: flex;
    align-items: center;
}
.member-avatar img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
}
.member-info{
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    justify-content: center;
    /* align-items: center; */
}
.member-name{
    height: 20px;
    line-height: 20px;
    
}
.user-item .member-name{
    cursor: pointer;
}
.member-email{
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #949aae;
}
.member-selection{
    flex: 0 0 20px;
    text-align: right;
    cursor: pointer;
}
.member-selection .components-icons-success:before{
    color: #2e68f8;
}
.member-selection.disable .components-icons-success:before{
    color: #c1cfff;
}
.member-unselect{
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;
    border: 1px solid #bfcbd9;
}
.user-item:hover{
    background: #fafcff;
}
.selected-title{
    margin: 6px 0 15px 0;
    line-height: 20px;
}
.list-actions.member-permission{
    right: unset;
    min-width: 0;
}
.member-permission-select{
    color: #2e68f8;
    cursor: pointer;
}
.el-dropdown-menu__item.list-action-item{
    padding: 0;
}
.selected-members{
    flex: 1;
    padding-right: 5px;
    min-height: 0;
    overflow-y: auto;
}
.contact-buttons{
    text-align: right;
    padding-top: 15px;
}
.elected-members{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}
.selected-item{
    display: flex;
    height: 40px;
    line-height: 40px;
    padding: 0 5px;
}
.selected-item:hover{
    background: #f7f9fc;
}
.selected-item .member-selection{
    display: none;
}
.selected-item:hover .member-selection{
    display: inline-block;
}
.empty-selected{
    color: #949aae;
}
.select-tip{
    display: inline-block;
    max-width: 200px;
    vertical-align: top;
}
.el-button--primary.is-plain{
  color: #fff;
  border-color: #2e68f8;
  background: #2e68f8;
}
.el-button--primary.is-plain:hover{
    background: #4377f8;
    border-color: #4377f8;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/Contact.vue